import { SetStateAction, useEffect, useState } from 'react'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { FoundationsRequest, getBaseUrl } from '../../Utils'
import { useClearFormFieldCacheMutation, useGenerateSchemaMutation, useGetCurrentFormsMutation } from '../../Redux/FormsEngineConfig/FormsEngineConfigSlice'
import { get } from 'sortablejs'
const helper = {
    log4netsuccess: 'Configuration saved successfully.',
    log4netfailure:
        'Sorry, something went wrong while saving Log4net configurations. Please try again.',
    generalsettingssuccess: 'General settings updated successfully.',
    generalsettingsfailure: 'Sorry, changes to general settings failed. Please try again.',
    notificationsetthingssuccess: 'Notification settings updated successfully.',
    notificationsetthingsfailure:
        'Sorry, changes to notification settings failed. Please try again.',
    passwordsettingssuccess: 'Password updated successfully.',
    passwordsettingsfailure: 'Sorry, changing password failed.',
    sendworkspaceasemailsuccess:
        'We are processing your request. Please check your email inbox shortly.',
    sendworkspaceasemailfailure: 'Sorry, sending workspace as email failed. Please try again.',
    lockallreportssuccess: 'Locked all reports in this workspace successfully.',
    lockallreportsfailure: 'Sorry, failed to lock all reports. Please try again.',
    formsengineclearcache: 'Cache cleared successfully!',
    formsenginecacheerror: 'Error clearing cache',
    sendEmptyInviteFailed: 'Please enter at least one name and email address to send invite to.',
    sendInviteFailed: 'Sending invite failed. Please try again.',
    resendInviteFailed: 'Resending invite failed. Please try again.',
    fetchInviteesFailed: 'Sorry, loading the invitees failed.',
}

const ManageFormsEngineConfig = () => {
    const [formMessage, setFormMessage] = useState('')
    const [getCurrentForms] = useGetCurrentFormsMutation()
    const [getCurrentSchema] = useGenerateSchemaMutation()
    const [clearFormCache] = useClearFormFieldCacheMutation()

    const updateCurrentForms = async (location: string) => {
        const requestersResult = await getCurrentForms({location:location}).unwrap()
        if (requestersResult !== undefined && requestersResult.CurrentForm !== undefined){
            setFormMessage(requestersResult.CurrentForm)
        }
    }

    const updateCurrentSchema = async () => {
        const schemaResult = await getCurrentSchema().unwrap()
        if (schemaResult !== undefined && schemaResult.CurrentForm !== undefined){
            setFormMessage(schemaResult.CurrentForm)
        }
    }
    const clearCache = async () => {
        const cacheResult = await clearFormCache().unwrap()
        setFormMessage("")
        FoundationsGenericToaster('success', helper.formsengineclearcache)
    }

    

    // const clickShowConfiguration = async (location: string) => {
    //     const formData = await getCurrentForms({location:location}).unwrap()
    //     setFormMessage(formData.CurrentForm)
    // }
    
    return (
        <div className="fluid">
            <div className="row">
                <div className="col-10">
                    <div className="header">Manage Forms Engine</div>
                </div>
                <div className="float-right margin-top-small">
                    <a id="link_backto_admin_tasks" href="#AdminTasks">
                        &laquo; Back to Admin Tasks
                    </a>
                </div>
            </div>

            <div id="formsEngine-content">
                <table className="input-form-table">
                    <tr>
                        <td className="left" style={{ width: ' 35%' }}>
                            <label htmlFor="TextBoxTracerLog">Show Forms on Database:</label>
                        </td>
                        <td className="right">
                            <input
                                type="button"
                                id="showConfigurationDB"
                                onClick={() => updateCurrentForms('DB')}
                                className="app-button clickShowConfig text-center"
                                value="Show from DB"
                                style={{ width: '190px' }}
                            />
                            <input
                                type="button"
                                id="showConfigurationServer"
                                onClick={() => updateCurrentForms('server')}
                                className="app-button clickShowConfig text-center"
                                value="Show from server"
                                style={{ width: '190px' }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="left" style={{ width: ' 35%' }}>
                            <label htmlFor="TextBoxTracerLog">Generate Schema Files:</label>
                        </td>
                        <td className="right">
                            <input
                                type="button"
                                id="generateSchema"
                                onClick={()=>updateCurrentSchema()}
                                className="app-button text-center"
                                value="Generate!"
                                style={{ width: '190px' }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className="left" style={{ width: ' 35%' }}>
                            <label htmlFor="clearFormFieldsCache">Clear Form Field Cache:</label>
                        </td>
                        <td className="right">
                            <input
                                type="button"
                                id="clearFormFieldsCache"
                                onClick={()=>{
                                    clearCache()
                                }}
                                className="app-button text-center"
                                value="Clear"
                                style={{ width: '190px' }}
                            />
                        </td>
                    </tr>
                </table>
            </div>

            <div>
                <span
                    className={'form-engine-message'}
                    style={{ marginRight: '10px' }}
                >
                    <span dangerouslySetInnerHTML={{__html:formMessage}}/>
                </span>
            </div>
        </div>
    )
}


export {ManageFormsEngineConfig}